import { useProfile, useLoadWishlist } from "../../../data/hooks";
import UserCard from "../../Components/UserCard";
import { Spin } from "antd";
import ToggleFriendButton from "@/views/Components/ToggleFriendButton";

export default function OwnerCard() {
  const [wishlist] = useLoadWishlist();
  const wishlistOwnerProfile = useProfile(wishlist?.userId);

  if (!wishlist) {
    return <Spin />;
  }

  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8">
      <UserCard
        id={wishlist.userId}
        name={wishlistOwnerProfile?.displayName || ""}
      />
      <div>{wishlistOwnerProfile?.description}</div>
      <ToggleFriendButton uid={wishlist.userId} />
    </div>
  );
}
